import clueManagement from './clueManagement/index.vue'
export default {
  clueManagement
}
